import React, { useState, useContext } from 'react';
import { Buscar } from '../componentes/Buscar';
  

export const Inicio=()=>{
    return(
        <Buscar/>
    );
}